import { jsxs, jsx, Fragment } from "../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import { AppBar } from "../app-bar/app-bar.es.js";
import Box from "../../../node_modules/@mui/material/Box/Box.es.js";
import { ModalBarIcon } from "./components/modal-icon.es.js";
import { ModalBarHeader } from "./components/modal-header.es.js";
import LinearProgress from "../../../node_modules/@mui/material/LinearProgress/LinearProgress.es.js";
function ModalBar({
  title,
  description,
  onStartIconClick,
  onEndIconClick,
  startIcon,
  startIconColor,
  endIcon,
  endIconColor,
  progressBar,
  progressValue,
  progressColor,
  ...rest
}) {
  startIconColor = startIconColor ?? "primary";
  endIconColor = endIconColor ?? "default";
  progressColor = progressColor ?? "success";
  progressValue = progressValue ?? 0;
  return /* @__PURE__ */ jsxs(Box, { ...rest, children: [
    /* @__PURE__ */ jsxs(AppBar, { children: [
      /* @__PURE__ */ jsx(ModalBarIcon, { "data-testid": "modal-bar-start-icon", color: startIconColor, icon: startIcon, onClick: onStartIconClick }),
      /* @__PURE__ */ jsx(ModalBarHeader, { "data-testid": "modal-bar-header", title, description }),
      /* @__PURE__ */ jsx(ModalBarIcon, { "data-testid": "modal-bar-end-icon", color: endIconColor, icon: endIcon, onClick: onEndIconClick })
    ] }),
    progressBar ? /* @__PURE__ */ jsx(Box, { width: "100%", "data-testid": "modal-bar-progress-container", children: /* @__PURE__ */ jsx(LinearProgress, { "data-testid": "modal-bar-progress", variant: "determinate", value: progressValue, color: progressColor }) }) : /* @__PURE__ */ jsx(Fragment, {})
  ] });
}
export {
  ModalBar
};
//# sourceMappingURL=modal-bar.es.js.map
